import { SET_SELECTED_ITEM } from './types';


export function setSelectedItem(state) {
    return {
        type: SET_SELECTED_ITEM,
        payload: state
    }
}